import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { SortByWrapper, Label, SortSelector, Option } from './SortBy.style';
import useFilterOptions from '../../hooks/Filters/useFilterOptions';
import { selectVehiclesOneGraph, setSortBy } from '../../redux/vehiclesReducer';

const SortBy: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { sortBy } = useSelector(selectVehiclesOneGraph);

  const { sortMethods } = useFilterOptions();

  const listOfSortMethods = Object.keys(sortMethods);

  const onHandleChange = (value: string) => {
    const sortId = sortMethods[value as keyof typeof sortMethods]?.id;
    const sortDirection = sortMethods[value as keyof typeof sortMethods]?.direction;
    const sortToUpload = {
      id: sortId,
      direction: sortDirection,
      value,
    };
    dispatch(setSortBy(sortToUpload));
  };

  return (
    <SortByWrapper data-testid="sort-by">
      <Label>{t('vlp.vehicleResults.sort.sortPrompt')}</Label>
      <SortSelector
        aria-label="sort by selector"
        value={sortBy.value}
        onChange={(e) => {
          onHandleChange(e.target.value);
        }}
      >
        {listOfSortMethods.map((option) => {
          return (
            <Option key={option} value={sortMethods[option as keyof typeof sortMethods]?.value}>
              {sortMethods[option as keyof typeof sortMethods]?.label}
            </Option>
          );
        })}
      </SortSelector>
    </SortByWrapper>
  );
};

export default SortBy;
